import { render } from "./StatisticsTabs.vue?vue&type=template&id=5687bb60&scoped=true&ts=true"
import script from "./StatisticsTabs.vue?vue&type=script&lang=ts"
export * from "./StatisticsTabs.vue?vue&type=script&lang=ts"

import "./StatisticsTabs.vue?vue&type=style&index=0&id=5687bb60&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5687bb60"]])

export default __exports__